import React from "react";
import * as RolePermissionConstants from "../../../../constants/RolePermissionConstants";
import { getUserRolePermission } from "../../../../utils/rolePermissionAccess";

class TeamRenderer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onTeamChange = (e, pipeLineOwnerList, rowId) => {
    if (e.target.value !== "") {
      const selectedPipeLineOwner = pipeLineOwnerList.find(
        (pipeLine) => pipeLine.emailId === e.target.value
      );

      this.props.onTeamChange(selectedPipeLineOwner, rowId);
    }
  };

  render() {
    const { pipeLineOwner = {}, selectedRowId } = this.props || {};

    return (
      <div key={this.props.rowId}>
        <select
          id="selectPinelineOwner"
          value={
            selectedRowId === this.props.rowId
              ? pipeLineOwner && pipeLineOwner.emailId
              : ""
          }
          onChange={(e) =>
            this.onTeamChange(e, this.props.pipeLineOwnerList, this.props.rowId)
          }
          style={{ textAlignLast: "center", width: "180px"}}
          disabled={
            !getUserRolePermission(
              RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_NEWVENDORS,
              RolePermissionConstants.VMP_SELECTDEOPDOWN
            ) === RolePermissionConstants.EDIT
          }
        >
          <option value="" selected hidden>
            {" "}
            Select{" "}
          </option>
          {this.props.pipeLineOwnerList &&
            this.props.pipeLineOwnerList.map((pipeLineOwner, index) => {
              return (
                <option
                  key={index}
                  style={{ backgroundColor: "lightgray" }}
                  value={pipeLineOwner.emailId}
                >
                  {pipeLineOwner.userName}
                </option>
              );
            })}
        </select>
      </div>
    );
  }
}

export default TeamRenderer;
